<!-- Built with Common Launchpad 4.0.2 -->

<template>
    <div class="filters-wrapperr">
        <aside class="filters">
        <button class="filters__trigger" @click="showModal">
            <span>Filter by Sector</span>
        </button>
        <div v-show="(isVisible && isSmallScreen) || !isSmallScreen" id="filter-overlay">
            <div class="filters__body">
            <div class="filters__menu">
                <div class="filters__heading">
                <span class="filters__title">Filter by</span>
                <button class="filters__close" @click="closeModal">
                    <img src="/icons/Custom/close.svg" alt="close">
                </button>
                </div>
                <div class="filters__content">
                <filter-group v-for="(filter, key, index) in data"
                                :filter="filter"
                                :key="key"
                                :index="index"
                                :class="filter.groupClassNames"
                                :specification="filter.specification"
                                @setSelectedValues="setSelectedValues(filter.specification, $event)"
                                @updateQueryValue="setQueryValue($event)"/>
                </div>
                <div class="filters__footer">
                <button class="filters__clear" @click="resetFilter">Clear ({{ count }})</button>
                <button class="filters__apply" @click="submit">Apply</button>
                </div>
            </div>
            </div>
        </div>
        </aside>

    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import FilterGroup from '../ui/filter-group';
import windowWidthMixin from '../../mixins/window-width';

export default {
  props: ['data', 'title'],
  mixins: [windowWidthMixin],
  data() {
    return {
      isVisible: false,
      selectedValues: {},
    }
  },
  components: {
    FilterGroup,
  },
  computed: {
    ...mapState({
      pagination: state => state.listing.pagination,
      specification: state => state.listing.specification,
    }),
    count() {
      return Object.values(this.selectedValues).reduce((sum, arr) => sum + arr.length, 0);
    }
  },
  watch: {
    isSmallScreen() {
      this.updateDomLocation();
    },
    windowWidth() {
      this.isVisible = false;
      document.body.classList.remove('no-scroll');
    }
  },
  methods: {
    ...mapActions('listing', {setFilter: 'setFilter'}),
    ...mapMutations('listing', {updateSpecification: 'updateSpecification'}),
    ...mapMutations('listing', {resetSpecification: 'resetSpecification'}),
    ...mapMutations('listing', {addNewTagFilter: 'addNewTagFilter'}),
    ...mapMutations('listing', {removeTagFilter: 'removeTagFilter'}),
    ...mapMutations('listing', {navigateToUrl: 'navigateToUrl'}),
    setQueryValue(val) {
      this.$store.commit('listing/updateQuery', val);
    },
    setSelectedValues(type, val) {
      this.$set(this.selectedValues, type, val.filter(el => el !== '999'));
    },
    updateDomLocation() {
      let target = document.body;
      const overlay = document.querySelector('.filters__overlay');
      const filter_overlay = document.getElementById('filter-overlay');
      const filters = document.querySelector('.filters');
      const header = document.querySelector('.header');

      let header_top = '150px';
      if (header !== undefined) {
        header_top = `${header.clientHeight}px`;
      }

      if (filter_overlay) {
        console.log('enter filter_overlay true');
        filter_overlay.style.setProperty('--menu-top', header_top);
      }

      if (!overlay) return; // Prevent errors if the element doesn't exist yet

      if (!this.isSmallScreen && filters) {
        target = filters; // Only update target if `.filters` exists
      }

      target.appendChild(overlay);
    },
    updateDomTriggerLocation() {
      if (!this.isSmallScreen) return;

      if (document.querySelector('.template.alliance-listing')) return;

      const target = document.getElementById('filters-anchor');
      const trigger = document.querySelector('.filters__trigger');
      if (!target || !trigger) return;

      target.appendChild(trigger);
    },
    showModal() {
      this.isVisible = !this.isVisible;
      if (this.isSmallScreen) {
        if (this.isVisible) {
          document.body.classList.add('no-scroll');
        } else {
          document.body.classList.remove('no-scroll');
        }
      }
    },
    closeModal() {
      this.isVisible = false;
      document.body.classList.remove('no-scroll');
    },
    filter() {
      this.setFilter();
    },
    resetFilter() {
      this.selectedValues = {};
      this.resetSpecification();
    },
    submit() {
      this.navigateToUrl();
      this.setFilter();
      this.isVisible = false;
      document.body.classList.remove('no-scroll');
    },
  },
  mounted() {
    this.query = this.specification.SearchTerm;
    this.updateDomLocation();
    this.updateDomTriggerLocation();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateDomTriggerLocation);
  }
}
</script>

<style lang="scss">
@import '../../../scss/_references.scss';

body {
  position: relative !important;

  &.no-scroll {
    overflow: hidden;
  }
}

.filters {
  @include media-breakpoint-up(lg) {
    //display: none;
  }

  &__trigger {
    background: #00703D;
    height: 3.5rem;
    border-radius: 1.75rem;
    width: 100%;
    display: none;
    justify-content: center;
    gap: .675rem;
    color: #FFFFFF;

    @include media-breakpoint-down(lg) {
      display: flex;
      border: 1px solid #FFFFFF;
      margin-top: 1.5rem;
    }


    i {
      margin: auto 0;
    }

    span {
      margin: auto 0;
      line-height: 1;
      font-weight: 700;
      font-size: 1.125rem;
    }
  }


  &__overlay {
    @include media-breakpoint-down(lg) {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 99999;
      background: rgba(0, 0, 0, 0.6);
      backdrop-filter: blur(22px);
    }
  }

  &__body {
    @include media-breakpoint-down(lg) {
      padding: 1.5rem;
      height: 100%;
    }
  }

  &__menu {
    @include media-breakpoint-down(lg) {
      border: 2px solid #DDE0DC;
      background: #EFF1EE;
      border-radius: 1.5rem;
      padding: 1.5rem;
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
    }
  }

  &__heading {
    display: none;

    @include media-breakpoint-down(lg) {
      display: flex;
      justify-content: space-between;
      gap: 1rem;
    }
  }

  &__title {
    margin: auto 0;
    line-height: 1;
    font-size: 1.875rem;
    font-weight: 700;
  }

  &__close {
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: .5rem;
    width: 2.5rem;
    height: 2.5rem;
    background: #333333;

    i {
      margin: 0 auto;
    }
  }

  &__content {
    flex: 1;
    display: grid;
    grid-template-columns: min-content min-content min-content 1fr 195px 200px;
    grid-template-rows: 1fr;
    grid-template-areas:
                "types topics upcoming . sort search";
    gap: .5rem;

    @include media-breakpoint-up(xl) {
      gap: 1.5rem;
    }

    @include media-breakpoint-down(lg) {
      gap: 1rem;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    }

    .group-search {
      grid-area: search;
      order: 1
    }

    .group-types {
      grid-area: types;
      order: 2
    }

    .group-topics {
      grid-area: topics;
      order: 3
    }

    .group-upcoming {
      grid-area: upcoming;
      order: 4
    }

    .group-sort {
      grid-area: sort;
      order: 5
    }
  }

  &__footer {
    display: none;
    justify-content: space-between;

    @include media-breakpoint-down(lg) {
      display: flex;
    }
  }

  &__clear,
  &__apply {
    height: 3.5rem;
    border: 2px solid #00703D;
    border-radius: 1.75rem;
    transition: ease .35s;

    @media screen and (max-width: 424px) {
        padding: 16px 35px;
    }
  }

  &__clear {
    color: #00703D;
    background: transparent;

    &:hover {
      background: #00703D;
      color: #FFFFFF;
    }
  }

  &__apply {
    color: #FFFFFF;
    background: #00703D;

    &:hover {
      background: darken(#00703D, 10%)
    }
  }
}

#filters-anchor.btn-bg-green {
  .filters__trigger {
    background: #00703D;
    color: #FFFFFF;
  }
}

#filters-anchor.btn-bg-green-ghost {
  .filters__trigger {
    background: $ic-white;
    color: $ic-green;
  }
}

#filters-anchor.btn-bg-white-ghost {
  .filters__trigger {
    background: transparent;
    color: $ic-white;
  }
}
</style>